import {useExternalControls} from "laravel-inertia-backend";
import HeaderNavExtraComponent from "./HeaderNavExtraComponent.jsx";
import SupportHeaderControl from "./Support/SupportHeaderControl.jsx";
import SupportSidebarControl from "./Support/SupportSidebarControl.jsx";
import SharedAccountLoginNotice from "./Support/SharedAccountLoginNotice.jsx";
import MenueUmschalter from "./Menue/MenueUmschalter.jsx";
import MenueFlyoutController from "./Menue/MenueFlyoutController.jsx";
import {version} from "../version.js";
import {useEffect} from "react";
import {usePage} from "@inertiajs/react";

export default function GlobalControls(props) {

    const context = useExternalControls();
    // Freigabe kommt aus HandleInertiaRequests (Superadmin immer, sonst nach
    // ROADMAP_PUBLIC-Einstellung) - der Link allein ist keine Zugriffssperre,
    // die eigentliche Prüfung sitzt im RoadmapController.
    const {roadmapVisible} = usePage().props;

    useEffect(() => {
        // Die Cronjob-Bedienelemente sind nur für Admins sichtbar (die
        // Komponente entscheidet das selbst); das Support-Icon dahinter gilt
        // für alle und rückt per ms-auto ans rechte Ende der Leiste, direkt
        // neben den Benutzernamen.
        context.setHeaderControls(
            <>
                <HeaderNavExtraComponent />
                <SupportHeaderControl />
            </>
        );
        // Fußbereich der Seitenleiste: "Tickets" (nur bei Freischaltung,
        // siehe SupportSidebarControl) und darunter die Versionsnummer mit
        // dem "Roadmap"-Link direkt daneben (nur sichtbar bei Freigabe -
        // siehe roadmapVisible oben). Bewusst ein einfacher <a>-Link statt
        // Inertias <Link>, aus demselben Grund wie beim Tickets-Eintrag in
        // SupportSidebarControl (Offcanvas schließt sonst nicht).
        context.setSidebarControls(
            <div className="sidebar-footer-controls">
                <MenueUmschalter />
                <SupportSidebarControl />
                <div className="sidebar-footer-version-row">
                    <div className="sidebar-footer-version">Version: {version}</div>
                    {roadmapVisible && (
                        <a href="/roadmap" className="sidebar-footer-roadmap-link">
                            Roadmap
                        </a>
                    )}
                </div>
            </div>
        );
    }, [roadmapVisible]);

    // Einmaliger Hinweis pro Sitzung für den Sammelzugang der Probearbeiter -
    // unabhängig von der Kopf-/Seitenleisten-Bedienung, siehe
    // SharedAccountLoginNotice. MenueFlyoutController rendert per Portal an
    // <body> (siehe dort) - hier nur einmal global gemountet.
    return (
        <>
            <SharedAccountLoginNotice />
            <MenueFlyoutController />
        </>
    );
}
